
<div>
    <app-bar :title="t('workout_executions_title')"/>

    <v-app-bar
        color="transparent"
        height="84"
        elevation="0"
        class="mb-n6 px-6"
    >
        <v-toolbar-title>{{ workoutExecution.workout.name }}</v-toolbar-title>
        <v-btn
            :to="{ name: 'workout-executions' }"
            plain
            icon
            absolute
            right
            class="mr-n8"
        ><v-icon>mdi-close</v-icon></v-btn>
    </v-app-bar>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <div class="px-10 pb-6 overflow-hidden">
            <workout-execution-view :execution="workoutExecution"></workout-execution-view>
        </div>

    </v-layout>
</div>
